import GridLine from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineItem from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";

interface IProps {
    totalNoShipmentRequiredItems: number;
};

const NoShipmentRequired: React.FC<IProps> = ({ totalNoShipmentRequiredItems }) => {
    if (!totalNoShipmentRequiredItems) {
        return null;
    }

    return (
        <GridLine
            settings={{
                columns: [{ width: 3 }, { width: 15 }]
            }}
            columns={[
                <GridLineItem>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{"No shipment required"}</FontBody1>
                </GridLineItem>,

                <GridLineItem>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{"Items"}</FontBody3>
                    <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{totalNoShipmentRequiredItems}</FontBody3>
                </GridLineItem>,
            ]} />
    );
};

export default NoShipmentRequired;